// extracted by mini-css-extract-plugin
export default {"headerCell":"TableHeaderCell-headerCell-aJDuw","sortIcon":"TableHeaderCell-sortIcon-zaT8O"};